import { render, staticRenderFns } from "./CallTemplate.vue?vue&type=template&id=2b44d887&"
import script from "./CallTemplate.vue?vue&type=script&lang=ts&"
export * from "./CallTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports